export default "__VITE_ASSET__CcJT3Bxv__"